import { useEffect, useState } from "react";

function HistorialMatriculas() {
  const [hijos, setHijos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchHistorialMatriculas = async () => {
      try {
        const res = await fetch("https://api.m3campus.com/api/historial-matriculas/", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.detail || "No se pudo cargar el historial de matrículas.");
        }

        setHijos(data.hijos || []);
      } catch (err) {
        setError(err.message || "Error inesperado.");
      } finally {
        setLoading(false);
      }
    };

    fetchHistorialMatriculas();
  }, []);

  if (loading) {
    return <div style={{ padding: "24px" }}>Cargando historial...</div>;
  }

  if (error) {
    return <div style={{ padding: "24px", color: "red" }}>{error}</div>;
  }

  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto", padding: "24px" }}>
      <h1>Historial de campus</h1>
      <p>Aquí puedes ver los campus ya realizados por tus hijos.</p>

      {hijos.length === 0 ? (
        <p>No hay historial de campus.</p>
      ) : (
        hijos.map(({ hijo, matriculas_historial = [] }) => (
          <div
            key={hijo.id}
            style={{
              border: "1px solid #ddd",
              borderRadius: "12px",
              padding: "20px",
              marginBottom: "24px",
              background: "#fff",
            }}
          >
            <h2 style={{ marginTop: 0 }}>
              {hijo.nombre} {hijo.apellidos}
            </h2>

            {hijo.fecha_nacimiento && (
              <p>
                <strong>Fecha de nacimiento:</strong> {hijo.fecha_nacimiento}
              </p>
            )}

            {matriculas_historial.length === 0 ? (
              <p>Este hijo no tiene historial de campus.</p>
            ) : (
              <div style={{ display: "grid", gap: "16px", marginTop: "16px" }}>
                {matriculas_historial.map((matricula) => (
                  <div
                    key={matricula.id}
                    style={{
                      border: "1px solid #eee",
                      borderRadius: "10px",
                      padding: "16px",
                      background: "#f9f9f9",
                    }}
                  >
                    <p><strong>Campus:</strong> {matricula.campus.nombre}</p>
                    <p><strong>Descripción:</strong> {matricula.campus.descripcion || "Sin descripción"}</p>
                    <p><strong>Precio:</strong> {matricula.campus.precio} €</p>
                    <p><strong>Fecha:</strong> {matricula.campus.fecha}</p>
                    <p><strong>Lugar:</strong> {matricula.campus.lugar}</p>
                    <p><strong>Estado:</strong> {matricula.estado_visual || "HISTORIAL"}</p>
                    <p><strong>Activada en:</strong> {matricula.activada_en}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default HistorialMatriculas;